import { useNavigate } from 'react-router-dom'
import AsignacionForm from '@/features/almacen/components/AsignacionForm'
import type { AsignacionFormPayload } from '@/features/almacen/components/AsignacionForm'
import { asignarHerramienta } from '@/features/almacen/api/movimientos.api'

/**
 * Alta de una asignación. La herramienta se elige dentro del formulario, por eso
 * esta ruta no lleva id.
 */
const AsignarPage = () => {
  const navigate = useNavigate()

  const guardar = async (payload: AsignacionFormPayload) => {
    await asignarHerramienta(payload.herramienta, {
      projectId:         payload.projectId,
      responsibleUserId: payload.responsibleUserId,
      warehouseId:       payload.warehouseId,
      notes:             payload.notes,
      evidenceUrl1:      payload.evidenceUrl1,
      evidenceUrl2:      payload.evidenceUrl2,
      evidenceUrl3:      payload.evidenceUrl3,
    })
    navigate('/almacen/asignacion')
  }

  return (
    <AsignacionForm
      mode="asignar"
      toolId=""
      onBack={() => navigate('/almacen/asignacion')}
      onSubmit={guardar}
    />
  )
}

export default AsignarPage
